export enum ApiResponseStatus{
    Ok = 0,
    Error = 1
}